var map = {
	"./AdsPictures.vue": 5914,
	"./CategoryNav.vue": 5348,
	"./CommonHeader.vue": 9527,
	"./Footer.vue": 2717,
	"./Header.vue": 8975,
	"./HeaderNav.vue": 5428,
	"./SearchInput.vue": 7394,
	"./VideoList.vue": 7073,
	"./VideoPlay.vue": 753,
	"./VideoTags.vue": 5380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5414;